import { ComponentType } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

/**
 * @deprecated
 * don't use it with new components,
 * it's needed only for legacy class components
 */
export interface PropsCustomWithRouter {
    router: {
        location: ReturnType<typeof useLocation>
        navigate: ReturnType<typeof useNavigate>
        params: Record<string, string | undefined>
    }
}

function customWithRouter(Component: ComponentType<any>) {
    function ComponentWithRouterProp(props: any) {
        const location = useLocation()
        const navigate = useNavigate()
        const params = useParams()

        return <Component {...props} router={{ location, navigate, params }} />
    }

    return ComponentWithRouterProp
}

export default customWithRouter
